import { animate, onScroll, splitText, cubicBezier, stagger } from 'animejs';
import globalVar from '../utils/globalVar'

class ScrollAnimations {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      initAnime();
    }

    let initCache = () => {
    // HERO
        cache.heroTitle = document.querySelectorAll('.anime-hero-title');
        cache.heroSurtitle = document.querySelectorAll('.anime-hero-surtitle');
        cache.heroText = document.querySelectorAll('.anime-hero-text');
        cache.heroBtn = document.querySelectorAll('.anime-hero-btn');
        cache.heroBtn2 = document.querySelectorAll('.anime-hero-btn2');
        cache.heroLine = document.querySelectorAll('.anime-hero-line');
        cache.heroProductImageBg = document.querySelectorAll('.anime-hero-product-image-bg');
        cache.heroProductImage = document.querySelectorAll('.anime-hero-product-image');
        cache.heroNewsWrapper = document.querySelectorAll('.anime-hero-news-wrapper');
        cache.heroForm = document.querySelectorAll('.anime-hero-form');
        cache.heroMedia = document.querySelectorAll('.anime-hero-media');
        cache.heroAnimeText = document.querySelectorAll('.anime-hero-box-text');
    
    // ANIMATION CLASSES
        cache.title = document.querySelectorAll('.anime-title');
        cache.titleMobile = document.querySelectorAll('.anime-title_mobile');
        cache.btn = document.querySelectorAll('.anime-btn');
        cache.btnMobile = document.querySelectorAll('.anime-btn_mobile');
        cache.text = document.querySelectorAll('.anime-text');
        cache.textMobile = document.querySelectorAll('.anime-text_mobile');
        cache.textLine = document.querySelectorAll('.anime-text-line');
        cache.container = document.querySelectorAll('.anime-container');
        cache.icon = document.querySelectorAll('.anime-icon');
        cache.boxMedia = document.querySelectorAll('.anime-box-media img, .anime-box-media video');
        cache.boxMediaMobile = document.querySelectorAll('.anime-box-media_mobile img, .anime-box-media_mobile video');
        cache.boxMediaSmall = document.querySelectorAll('.anime-box-media_small img, .anime-box-media_small video');
        cache.bgMedia = document.querySelectorAll('.anime-bg-media');
        cache.fade = document.querySelectorAll('.anime-fade');
        cache.gallery = document.querySelectorAll('.anime-gallery');
        cache.animeSliderContainer = document.querySelectorAll('.anime-slider_container');
        // cache.animeSliderCollection = document.querySelectorAll('.anime-slider-collection');
        cache.cards = document.querySelectorAll('.anime-cards');
        cache.review = document.querySelectorAll('.anime-review');
        cache.animeBgParallax = document.querySelectorAll('.anime-bg-parallax img, .anime-bg-parallax video');
        cache.animeTimepiece = document.querySelectorAll('.anime-timepiece');
        cache.bgLotus = document.querySelectorAll('.bg_lotus');
        cache.footer = document.querySelector('footer .footer_inner');
    //   cache.miniLotusFooter = document.querySelectorAll('.anime-mini-lotus_footer');
    };

    let initAnime = () => {

// HERO TITLE
        if (cache.heroTitle) {
            cache.heroTitle.forEach((el) => {
                const splitter = splitText(el, { chars: {} });
                splitter.addEffect(({ chars }) => {
                    el.style.opacity = '1';

                    // Prevent mid-word line breaks using anime.js word wrappers (already in DOM)
                    splitter.words.forEach(word => {
                        word.style.display = 'inline-block';
                        word.style.whiteSpace = 'nowrap';
                    });

                    // Wrap each char in an overflow:hidden span for the mask/clip effect
                    chars.forEach(char => {
                        const clip = document.createElement('span');
                        clip.style.cssText = 'display:inline-block;overflow:hidden;vertical-align:bottom;';
                        char.parentNode.insertBefore(clip, char);
                        clip.appendChild(char);
                        char.style.display = 'inline-block';
                    });

                    animate(chars, {
                        opacity: [0, 0, 1],
                        y: ['110%', '0%'],
                        delay: stagger(25),
                        duration: 1000,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                    });
                });
            });
        }

// HERO SURTITLE
        if (cache.heroSurtitle) {
            cache.heroSurtitle.forEach((el) => {
                splitText(el, { chars: {} }).addEffect(({ chars }) => {
                    el.style.opacity = '1';
                    chars.forEach(char => {
                        const clip = document.createElement('span');
                        clip.style.cssText = 'display:inline-block;overflow:hidden;vertical-align:bottom;';
                        char.parentNode.insertBefore(clip, char);
                        clip.appendChild(char);
                        char.style.display = 'inline-block';
                    });

                    animate(chars, {
                        opacity: [0, 0, 1],
                        y: ['110%', '0%'],
                        delay: 400,
                        duration: 800,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                    });
                });
            });
        }

// HERO TEXT
        if (cache.heroText) {
            cache.heroText.forEach((el) => {
                splitText(el, { chars: {} }).addEffect(({ chars }) => {
                    el.style.opacity = '1';
                    const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || parseFloat(getComputedStyle(el).fontSize) * 1.2;
                    chars.forEach(char => {
                        const clip = document.createElement('span');
                        clip.style.cssText = `display:inline-block;overflow:hidden;vertical-align:bottom;height:${lineHeight}px;`;
                        char.parentNode.insertBefore(clip, char);
                        clip.appendChild(char);
                        char.style.display = 'inline-block';
                    });

                    animate(chars, {
                        opacity: [0, 0, 1],
                        y: ['110%', '0%'],
                        delay: stagger(15),
                        duration: 700,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                    });
                });
            });
        }

// HERO BTN
        if (cache.heroBtn) {
            cache.heroBtn.forEach((el) => {
                splitText(el, { chars: {} }).addEffect(({ chars }) => {
                    el.style.opacity = '1';
                    chars.forEach(char => {
                        const clip = document.createElement('span');
                        char.parentNode.insertBefore(clip, char);
                        clip.appendChild(char);
                    });

                    animate(chars, {
                        opacity: [0, 0, 1],
                        delay: stagger(10, {start: 1400}),
                        duration: 800,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                        onComplete: () => {
                            el.classList.add('done');
                        }
                    });
                });
            });
        }

// HERO BTN 2
        if (cache.heroBtn2) {
            cache.heroBtn2.forEach((el) => {
                splitText(el, { chars: {} }).addEffect(({ chars }) => {
                    el.style.opacity = '1';
                    chars.forEach(char => {
                        const clip = document.createElement('span');
                        char.parentNode.insertBefore(clip, char);
                        clip.appendChild(char);
                    });

                    animate(chars, {
                        opacity: [0, 0, 1],
                        delay: stagger(10, {start: 400}),
                        duration: 800,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                        onComplete: () => {
                            el.classList.add('done');
                        }
                    });
                });
            });
        }

// HERO LINE
        if (cache.heroLine) {
            cache.heroLine.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    delay: 2000,
                    duration: 800,
                    ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                });
            });
        }

// HERO PRODUCT IMAGE BG
        if (cache.heroProductImageBg) {
            cache.heroProductImageBg.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    y: ["50%", "0%"],
                    delay: 500,
                    duration: 1000,
                    ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                });
            });
        }

// HERO PRODUCT IMAGE
        if (cache.heroProductImage) {
            cache.heroProductImage.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    scale: [1.05, 1],
                    delay: 200,
                    duration: 1000,
                    ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                });
            });
        }

// HERO NEWS WRAPPER
        if (cache.heroNewsWrapper) {
            cache.heroNewsWrapper.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    y: ["5%", "0%"],
                    delay: 800,
                    duration: 1200,
                    ease: "outSine",
                });
            });
        }

// HERO FORM
        if (cache.heroForm) {
            cache.heroForm.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    duration: 800,
                    ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                });
            });
        }

// HERO ANIME IMAGE
        if (cache.heroMedia) {
            cache.heroMedia.forEach((el) => {
                animate(el.querySelector('img,video'), {
                    y: ["-50%", "-30%"],
                    x: ["-50%", "-50%"],
                    scale: [1.1, 1],
                    autoplay: onScroll({
                        target: el.parentElement,
                        axis: 'y',
                        enter: "start start",
                        leave: "start end",
                        sync: true,
                    })
                });
            });
        }

// HERO ANIME TEXT
        if (cache.heroAnimeText) {
            cache.heroAnimeText.forEach((el) => {
                animate(el, {
                    y: ["0", "-50%"],
                    scale: [1, 0.95],
                    autoplay: onScroll({
                        target: el.parentElement,
                        axis: 'y',
                        enter: "start start",
                        leave: "start end",
                        sync: true,
                    })
                });
            });
        }



// HERO LOTUS
        if (cache.heroLotus) {
            cache.heroLotus.forEach((el) => {
                animate(el, {
                    opacity: [0, 1],
                    duration: 800,
                    delay: 200,
                    ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                });
            });
        }

// ANIME TITLE        
        if (cache.title) {
            cache.title.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }

// ANIME TITLE MOBILE        
        if (cache.titleMobile && globalVar.mobile.matches) {
            cache.titleMobile.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }


// ANIME BTN
        if (cache.btn) {
            cache.btn.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }

// ANIME BTN MOBILE
        if (cache.btnMobile && globalVar.mobile.matches) {
            cache.btnMobile.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }

// ANIME TEXT   
        if (cache.text) {
            cache.text.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }

// ANIME TEXT MOBILE   
        if (cache.textMobile && globalVar.mobile.matches) {
            cache.textMobile.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }

// ANIME TEXT
        const animateTextLine = (p) => {
            if (p.textContent.replace(/\u00A0/g, '').trim() === '') return;
            // WYSIWYG paragraphs with child HTML elements (strong, span, etc.)
            // are not compatible with splitText — animate the whole paragraph instead
            if (p.children.length > 0) {
                animate(p, {
                    opacity: [0.3, 1, 1, 1, 1, 0.3],
                    autoplay: onScroll({
                        target: p,
                        axis: 'y',
                        enter: "end start",
                        leave: "top bottom",
                        sync: true,
                    })
                });
                return;
            }
            splitText(p, {
                lines: { wrap: 'clip' },
            }).addEffect(({ lines }) => {
                if (getComputedStyle(p).textAlign === 'justify') {
                    lines.forEach((line, i) => {
                        line.style.textAlignLast = i < lines.length - 1 ? 'justify' : 'left';
                    });
                }
                lines.forEach(line =>
                    animate(line, {
                        opacity: [0.3, 1, 1, 1, 1, 0.3],
                        autoplay: onScroll({
                            target: line,
                            axis: 'y',
                            enter: "end start",
                            leave: "top bottom",
                            sync: true,
                        })
                    })
                );
            });
        };

        if (cache.textLine) {
            cache.textLine.forEach((el) => {
              el.querySelectorAll('p').forEach(p => animateTextLine(p));
            });
        }

// ANIME TEXT MOBILE
        if (cache.textLineMobile && globalVar.mobile.matches) {
            cache.textLineMobile.forEach((el) => {
              el.querySelectorAll('p').forEach(p => animateTextLine(p));
            });
        }
        
// ANIME CONTAINER
        if (cache.container) {
            if (globalVar.desktop.matches) {
                cache.container.forEach((el) => {
                    animate(el, {
                    y: ["10%", "-10%"],
                    autoplay: onScroll({
                        target: el,
                        axis: 'y',
                        enter: "end start",
                        leave: "top bottom",
                        sync: 0.25,
                    })
                });
            });
            }
        }
        
// ANIME ICON
        if (cache.icon) {
            cache.icon.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                scale: [0.95, 1, 1, 1, 0.95],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "top bottom",
                    sync: true,
                })
            });
            });
        }
        
// ANIME BOX IMAGE
        if (cache.boxMedia) {
            cache.boxMedia.forEach((el) => {
                if(el.closest('.anime-box-media').classList.contains('media-ratio')) {
                    animate(el, {
                        y: ["-15%", "15%"],
                        autoplay: onScroll({
                            target: el.parentElement,
                            axis: 'y',
                            enter: "end start",
                            leave: "start end",
                            sync: true,
                        })
                    });
                } else {
                    animate(el, {
                        y: ["-60%", "-40%"],
                        x: ["-50%", "-50%"],
                        autoplay: onScroll({
                            target: el.parentElement,
                            axis: 'y',
                            enter: "end start",
                            leave: "start end",
                            sync: true,
                        })
                    });
                }
            });
        }

// ANIME BOX IMAGE MOBILE
        if (cache.boxMediaMobile && globalVar.mobile.matches ) {
            cache.boxMediaMobile.forEach((el) => {
                if(el.closest('.anime-box-media_mobile').classList.contains('media-ratio')) {
                    animate(el, {
                        y: ["-10%", "10%"],
                        autoplay: onScroll({
                            target: el.parentElement,
                            axis: 'y',
                            enter: "end start",
                            leave: "start end",
                            sync: true,
                        })
                    });
                } else {
                    animate(el, {
                        y: ["-55%", "-45%"],
                        x: ["-50%", "-50%"],
                        autoplay: onScroll({
                            target: el.parentElement,
                            axis: 'y',
                            enter: "end start",
                            leave: "start end",
                            sync: true,
                        })
                    });
                }
            });
        }
        
// ANIME BOX IMAGE SMALL
        if (cache.boxMediaSmall) {
            cache.boxMediaSmall.forEach((el) => {
                animate(el, {
                y: ["-52%", "-45%"],
                x: ["-50%", "-50%"],
                autoplay: onScroll({
                    target: el.parentElement,
                    axis: 'y',
                    enter: "end start",
                    leave: "start end",
                    sync: true,
                })
            });
            });
        }
        
// ANIME BG MEDIA
        if (cache.bgMedia) {
            cache.bgMedia.forEach((el) => {
                const content = el.closest('section').querySelector('.anime-bg-media_content');
                const media = el.closest('section').querySelector('.media-container');
                if(media) {
                    animate(media, {
                        scale: [0.8,1],
                        autoplay: onScroll({
                            target: el,
                            axis: 'y',
                            enter: "end start",
                            leave: "top top",
                            sync: true,
                        })
                    });
                }

                if(globalVar.desktop.matches) {
                    animate(el, {
                        y: ["20%", "0%"],
                        autoplay: onScroll({
                            target: el,
                            axis: 'y',
                            enter: "end start",
                            leave: "top top-=50px",
                            sync: true,
                        })
                    });
                }

                if(content) {
                    // if(content.classList.contains('anime-bg-media_content-align-left')) {
                    //     animate(content, {
                    //         opacity: [0, 0, 1, 1, 1, 1, 1],
                    //         x: ["12%", "0%"],
                    //         autoplay: onScroll({
                    //             target: content,
                    //             axis: 'y',
                    //            enter: "end start",
                    //             leave: "top top-=50px",
                    //             sync: 0.5,
                    //         })
                    //     });
                    // } else if(content.classList.contains('anime-bg-media_content-align-right')) {
                    //     animate(content, {
                    //         opacity: [0, 0, 1, 1, 1, 1, 1],
                    //         x: ["-12%", "0%"],
                    //         autoplay: onScroll({
                    //             target: content,
                    //             axis: 'y',
                    //            enter: "end start",
                    //             leave: "top top-=50px",
                    //             sync: 0.5,
                    //         })
                    //     });
                    // } else {
                       animate(content, {
                            opacity: [0, 1, 1, 1, 1, 0],
                            y: ["50%", "-50%"],
                            autoplay: onScroll({
                                target: content,
                                axis: 'y',
                                enter: "end start",
                                leave: "top top",
                                sync: 0.5,
                            })
                        });
                    // }
                }

                // onScroll({
                //     target: el,
                //     axis: 'y',
                //     enter: "end start",
                //     leave: "top top-=75px",
                //     onLeaveForward: () => {
                //         if (content && !content.classList.contains('is-visible')) {
                //             content.classList.add('is-visible');
                //             animate(content, {
                //                 opacity: [0, 1],
                //                 y: ["10%", "0%"],
                //                 duration: 600,
                //                 ease: "outSine"
                //             });
                //         }
                //     },
                //     onLeaveBackward: () => {
                //         if (content && content.classList.contains('is-visible')) {
                //             content.classList.remove('is-visible');
                //             animate(content, {
                //                 opacity: [1, 0],
                //                 y: ["0%", "-10%"],
                //                 duration: 600,
                //                 ease: "outSine"
                //             });
                //         }
                //     },
                // });
            });
        }


// ANIME FADE
        if(cache.fade) {
            cache.fade.forEach((el) => {
                animate(el, {
                opacity: [0.3, 1, 1, 1, 0.3],
                scale: [0.98, 1, 1, 1, 0.98],
                y: ["10%", "0%", "0%", "0%", "0%"],
                autoplay: onScroll({
                    target: el,
                    axis: 'y',
                    enter: "end start",
                    leave: "center center",
                    sync: true,
                })
            });
            });
        }


// ANIME GALLERY
        if(cache.gallery) {
            cache.gallery.forEach((el) => {
                const items = [...el.querySelectorAll('.gallery-item')];
                const colWidth = items[0].offsetWidth;
                const minLeft = Math.min(...items.map(el => el.offsetLeft));

                items.forEach((el) => {
                    const col = Math.round((el.offsetLeft - minLeft) / colWidth);
                    animate(el, {
                        y: ['50%', '0%'],
                        autoplay: onScroll({
                            target: el,
                            axis: 'y',
                            enter: `end+=${(col * -120)+200}px start`,
                            leave: "center center",
                            sync: true,
                        })
                    });
                    animate(el.querySelector(".bg_media"), {
                        scale: [1.1, 1],
                        autoplay: onScroll({
                            target: el,
                            axis: 'y',
                            enter: `end+=${(col * -120)+200}px start`,
                            leave: "center center",
                            sync: true,
                        })
                    });
                });

            });
        }

// ANIME SLIDER CONTAINER
        if(cache.animeSliderContainer) {
            cache.animeSliderContainer.forEach((el) => {
                const module = el.closest('section');
                if (!module) return;
                const spacer = document.querySelector('.slider-spacer_'+module.id);
                if (!spacer) return;
                animate(el, {
                opacity: [0.3, 1, 1, 0.3],
                    autoplay: onScroll({
                        target: spacer,
                        axis: 'y',
                        enter: "end start",
                        leave: "top bottom+="+module.offsetHeight,
                        sync: true,
                    })
                });
            });
        }

// ANIME CARDS
        if(cache.cards) {
            cache.cards.forEach((el) => {
                const items = [...el.querySelectorAll('.item')];
                const colWidth = items[0].offsetWidth;
                const minLeft = Math.min(...items.map(el => el.offsetLeft));

                items.forEach((item) => {
                    const col = Math.round((item.offsetLeft - minLeft) / colWidth);
                    animate(item, {
                        y: ['40%', '0%'],
                        autoplay: onScroll({
                            target: item,
                            axis: 'y',
                            enter: `end+=${(col * -160)+600}px start`,
                            leave: "center+=250px center",
                            sync: true,
                        })
                    });
                    animate(item.querySelector(".card-inner"), {
                        scale: [1.2, 1],
                        autoplay: onScroll({
                            target: item,
                            axis: 'y',
                            enter: `end+=${(col * -160)+500}px start`,
                            leave: "center+=250px center",
                            sync: true,
                        })
                    });
                });

            });
        }

// ANIME REVIEW
        if(cache.review) {
            cache.review.forEach((el) => {
                el.querySelectorAll('p').forEach(p => {
                    if (p.textContent.replace(/\u00A0/g, '').trim() === '') return;
                    // Lock height before split so layout never shifts
                    p.style.height = p.offsetHeight + 'px';
                    splitText(p, {
                        chars: {},
                    }).addEffect(({ chars }) => {
                        const n      = chars.length;
                        const spread = 0.8;
                        // Read text color once — used to build rgba() values
                        const rgb    = getComputedStyle(p).color.match(/\d+/g) || ['255','255','255'];
                        const [r, g, b] = rgb;
                        const prevAlpha = new Float32Array(n).fill(0.3);

                        // Use `color: rgba()` instead of `opacity`.
                        // opacity < 1 creates a stacking context per element — 300 of them
                        // creates 300 compositor layers which causes scroll lag.
                        // color: rgba() has no such cost: text is painted in a single pass
                        // as part of normal text flow with no compositing overhead.
                        // Also: keep spans as display:inline (no display change) so there
                        // are no separate inline-block formatting contexts.
                        chars.forEach(char => {
                            char.style.color = `rgba(${r},${g},${b},0.3)`;
                        });

                        onScroll({
                            target: p,
                            axis: 'y',
                            enter: "end top",
                            leave: "center-=100 center",
                            onUpdate: ({ progress }) => {
                                for (let i = 0; i < n; i++) {
                                    const start = (i / n) * spread;
                                    const charP = progress <= start                ? 0
                                                : progress >= start + (1 - spread) ? 1
                                                : (progress - start) / (1 - spread);
                                    const alpha = 0.3 + charP * 0.7;
                                    if (Math.abs(alpha - prevAlpha[i]) > 0.004) {
                                        prevAlpha[i] = alpha;
                                        chars[i].style.color = `rgba(${r},${g},${b},${alpha})`;
                                    }
                                }
                            }
                        });
                    });
                });
            });
        }

// ANIME BG PARALLAX
        if(cache.animeBgParallax) {
            cache.animeBgParallax.forEach((el) => {
                const section = el.closest('section');
                if (!section) return;
                animate(el, {
                    y: ["-40%", "-60%"],
                    x: ["-50%", "-50%"],
                    autoplay: onScroll({
                        target: section,
                        axis: 'y',
                        enter: "end start",
                        leave: "start end",
                        sync: true,
                    })
                });
            });
        }

// ANIME BG LOTUS
        if(cache.bgLotus) {
            cache.bgLotus.forEach((el) => {
                const rect = el.getBoundingClientRect();
                const isInView = rect.top < window.innerHeight && rect.bottom > 0;

                if (isInView) {
                    // Element is visible on page load — animate in like hero, then hand off to scroll for exit
                    animate(el, {
                        opacity: [0, 1],
                        scale: [1.3, 1],
                        duration: 800,
                        ease: cubicBezier(0.567, -0.013, 0.493, 0.98),
                        onComplete: () => {
                            animate(el, {
                                opacity: [1, 0],
                                scale: [1, 1.3],
                                autoplay: onScroll({
                                    target: el,
                                    axis: 'y',
                                    enter: "top start",
                                    leave: "center start",
                                    sync: true,
                                })
                            });
                        }
                    });
                } else {
                    animate(el, {
                        opacity: [0, 1, 1, 0],
                        scale: [1.3, 1, 1, 1.3],
                        autoplay: onScroll({
                            target: el,
                            axis: 'y',
                            enter: "center start",
                            leave: "top bottom",
                            sync: true,
                        })
                    });
                }
            });
        }

// ANIME TIMEPIECE
        if(cache.animeTimepiece) {
            cache.animeTimepiece.forEach((el) => {
                animate(el, {
                    opacity: [0, 1, 1, 1, 0.3],
                    y: ['50%', "0%", "0%", "0%"],
                    scale: [1.5, 1, 1, 1],
                    autoplay: onScroll({
                        target: el,
                        axis: 'y',
                        enter: "end start",
                        leave: "top bottom",
                        sync: true,
                    })
                });
            });
        }

// FOOTER
        if(cache.footer) {
            const wrapper = document.querySelector('.wrapper');
            if(wrapper) animate(cache.footer, {
                opacity: [0, 1],
                scale: [0.985, 1],
                y: ["10%", "0%"],
                autoplay: onScroll({
                    target: wrapper,
                    axis: 'y',
                    enter: "bottom bottom",
                    leave: "bottom-="+(cache.footer.closest('footer').offsetHeight)+"px bottom",
                    // On mobile, lerp instead of hard sync so iOS bounce
                    // oscillations don't drive the animation 1:1
                    sync: globalVar.mobile.matches ? 0.08 : true,
                })
            });
        }

// ANIME MINI LOTUS

        // if (cache.miniLotusFooter) {
        //     cache.miniLotusFooter.forEach((el) => {
        //         animate(el, {
        //         rotate: [180,0],
        //         autoplay: onScroll({
        //             target: el,
        //             axis: 'y',
        //             enter: "center center",
        //             leave: "top top",
        //             sync: true,
        //         })
        //     });
        //     });
        // }

    };
    

    initFunc();

    // Re-initialize scroll animations for dynamically added items (e.g. AJAX load more).
    // Dispatch 'scrollAnimations:reinit' with { detail: { newItems: [...elements] } } to trigger.
    const reinitForItems = (items) => {
      items.forEach((item) => {
        const find = (sel) => {
          const children = [...item.querySelectorAll(sel)];
          return item.matches(sel) ? [item, ...children] : children;
        };

        // BOX MEDIA parallax
        find('.anime-box-media img, .anime-box-media video').forEach((el) => {
          const wrapper = el.closest('.anime-box-media');
          if (wrapper.classList.contains('media-ratio')) {
            animate(el, { y: ['-15%', '15%'], autoplay: onScroll({ target: el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
          } else {
            animate(el, { y: ['-60%', '-40%'], x: ['-50%', '-50%'], autoplay: onScroll({ target: el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
          }
        });

        // BOX MEDIA MOBILE
        if (globalVar.mobile.matches) {
          find('.anime-box-media_mobile img, .anime-box-media_mobile video').forEach((el) => {
            const wrapper = el.closest('.anime-box-media_mobile');
            if (wrapper.classList.contains('media-ratio')) {
              animate(el, { y: ['-15%', '15%'], autoplay: onScroll({ target: el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
            } else {
              animate(el, { y: ['-60%', '-40%'], x: ['-50%', '-50%'], autoplay: onScroll({ target: el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
            }
          });
        }

        // BOX MEDIA SMALL
        find('.anime-box-media_small img, .anime-box-media_small video').forEach((el) => {
          animate(el, { y: ['-52%', '-45%'], x: ['-50%', '-50%'], autoplay: onScroll({ target: el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
        });

        // TITLE
        find('.anime-title').forEach((el) => {
          animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
        });

        // TITLE MOBILE
        if (globalVar.mobile.matches) {
          find('.anime-title_mobile').forEach((el) => {
            animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
          });
        }

        // BTN
        find('.anime-btn').forEach((el) => {
          animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
        });

        // BTN MOBILE
        if (globalVar.mobile.matches) {
          find('.anime-btn_mobile').forEach((el) => {
            animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
          });
        }

        // TEXT
        find('.anime-text').forEach((el) => {
          animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
        });

        // TEXT MOBILE
        if (globalVar.mobile.matches) {
          find('.anime-text_mobile').forEach((el) => {
            animate(el, { opacity: [0.3, 1, 1, 1, 0.3], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
          });
        }

        // ICON
        find('.anime-icon').forEach((el) => {
          animate(el, { opacity: [0.3, 1, 1, 1, 0.3], scale: [0.95, 1, 1, 1, 0.95], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: true }) });
        });

        // FADE
        find('.anime-fade').forEach((el) => {
          animate(el, { opacity: [0.3, 1, 1, 1, 0.3], scale: [0.98, 1, 1, 1, 0.98], y: ['10%', '0%', '0%', '0%', '0%'], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'center center', sync: true }) });
        });

        // CONTAINER (desktop only)
        if (globalVar.desktop.matches) {
          find('.anime-container').forEach((el) => {
            animate(el, { y: ['10%', '-10%'], autoplay: onScroll({ target: el, axis: 'y', enter: 'end start', leave: 'top bottom', sync: 0.25 }) });
          });
        }

        // BG PARALLAX
        find('.anime-bg-parallax img, .anime-bg-parallax video').forEach((el) => {
          const section = el.closest('section');
          animate(el, { y: ['-40%', '-60%'], x: ['-50%', '-50%'], autoplay: onScroll({ target: section || el.parentElement, axis: 'y', enter: 'end start', leave: 'start end', sync: true }) });
        });
      });
    };

    document.addEventListener('scrollAnimations:reinit', (e) => {
      const newItems = e.detail && e.detail.newItems;
      if (newItems && newItems.length) reinitForItems(newItems);
    });
  };
}
export { ScrollAnimations }